export const TIERS = {
  SHAI_HULUD: "Shai Hulud Founding Sponsor",
  TBM_PARTNER: "TBM Partner",
  GROUNDHOG: "Groundhog Supporter",
};

export const sponsors = [
  // ─── SHAI HULUD FOUNDING SPONSORS ────────────────────────────────────────
  {
    name: "Ulysses Holdings",
    src: "/images/UDH Logo Stacked FULL - 300dpi.jpg",
    link: "https://www.ulyssesholdings.com/",
    tier: TIERS.SHAI_HULUD,
    description: `Major founding sponsor — cash\n\nUlysses Holdings develops, finances, and supports high-growth companies through investments and professional support.`,
  },
  {
    name: "SimScale",
    src: "/images/simscale sponsor logo.svg",
    link: "https://www.simscale.com/academic-program/",
    tier: TIERS.SHAI_HULUD,
    description: `SimScale Academic Sponsorship:\n\n5,000 core hours per year\nCFD and FEA analyses for TBM design optimization`,
  },
  {
    name: "Master Builders Solutions",
    src: "/images/Master-Builders-Solutions_Logo_Color.svg.png",
    link: "https://master-builders-solutions.com/en-us/products/masterroc/masterroc-acp-214/",
    tier: TIERS.SHAI_HULUD,
    description: `Supplies MasterRoc ACP 214 anti-clay polymer:\n\nImproves soil conditioning for clay-rich ground\nReduces cutterhead torque and sticking`,
  },
  {
    name: "Jema Motors",
    src: "/images/JEMA Logo - White Background.png",
    link: "https://www.jemamotors.com/",
    tier: TIERS.SHAI_HULUD,
    description: `Provides the mucking motor for our TBM material handling system.`,
  },
  {
    name: "Phoenix Contact",
    src: "/images/phoenix contact logo.png",
    link: "https://www.phoenixcontact.com/",
    tier: TIERS.SHAI_HULUD,
    description: `Supplies terminal blocks, power supplies, relay modules, and automation software.`,
  },
  {
    name: "MSC Industrial",
    src: "/images/msc industrial logo.png",
    link: "https://www.mscdirect.com/",
    tier: TIERS.SHAI_HULUD,
    description: `Cutting tools, industrial supplies, and reliable supply chain for project needs.`,
  },
  {
    name: "Texas Iron and Metal",
    src: "/images/Texas Iron and Metal Logo from online.jpg",
    link: "https://www.texasironandmetal.com/",
    tier: TIERS.SHAI_HULUD,
    description: `Thank you to Max Reichenthal and the Texas Iron and Metal crew for sponsoring us with 7,000 lbs of steel!`,
  },
  {
    name: "Sarabi Studio",
    src: "/images/sarabi logo.jpg",
    link: "",
    tier: TIERS.SHAI_HULUD,
    description: `Excellent deals on 3/8 in prime steel. Top-tier laser cutting and bending. Wonderful team!`,
  },
  {
    name: "Maddox Transformers",
    src: "/images/Maddox logo.png",
    link: "https://www.maddoxtransformers.com/",
    tier: TIERS.SHAI_HULUD,
    description: `High-leg delta transformer powering our actuators and welder.`,
  },
  {
    name: "Prysmian",
    src: "/images/prysmian logo.png",
    link: "https://www.prysmian.com/",
    tier: TIERS.SHAI_HULUD,
    description: `Hundreds of feet of SOOW and Type W power cable for our 2026–27 machine.`,
  },
  {
    name: "Westbrook Metals",
    src: "/images/sponsors/westbrook-metals.png",
    link: "https://www.westbrookmetals.com/",
    tier: TIERS.SHAI_HULUD,
    description: `4× 24-in OD steel pipes, 48 in long each, for our TBM shell and pipe jacking. Thank you!`,
  },

  // Entries marked "TODO: confirm what they provided" come from the Drive's tier
  // folders (logos added March 2026) but aren't in the Sponsorship status sheet.
  {
    // TODO: confirm what they provided and their website link
    name: "The Austin DIY Shop",
    src: "/images/sponsors/austin-diy-shop.png",
    link: "",
    tier: TIERS.SHAI_HULUD,
    description: `Thank you for supporting the UATXcavators!`,
  },
  {
    // TODO: confirm what they provided
    name: "AWC",
    src: "/images/sponsors/awc.png",
    link: "https://www.awc-inc.com/",
    tier: TIERS.SHAI_HULUD,
    description: `Thank you for supporting the UATXcavators!`,
  },

  // ─── TBM PARTNERS ────────────────────────────────────────────────────────
  {
    name: "Brackenridge Field Laboratory",
    src: "/images/Brackenridge Field Laboratory logo.png",
    link: "https://fieldstations.utexas.edu/field-stations/brackenridge-field-laboratory",
    tier: TIERS.TBM_PARTNER,
    description: `82-acre tract of land for field testing.\nResearch facility operated by UT Austin.`,
  },
  {
    name: "Bender Inc",
    src: "/images/Bender Inc logo.png",
    link: "https://www.benderinc.com/",
    tier: TIERS.TBM_PARTNER,
    description: `LINETRAXX RCM420 residual current monitor and CTAC measuring current transformer for ground-fault protection on our power system.`,
  },
  {
    name: "Gaba Printing",
    src: "/images/Gaba Printing logo.png",
    link: "",
    tier: TIERS.TBM_PARTNER,
    description: `Printing and fabrication sponsor.`,
  },
  {
    name: "SEW Eurodrive",
    src: "/images/SEW logo.png",
    link: "https://www.seweurodrive.com/",
    tier: TIERS.TBM_PARTNER,
    description: `Drive technology and automation systems sponsor.`,
  },
  {
    name: "Philip and Susan Klein",
    src: "/images/philip and susan klein logo.png",
    link: "",
    tier: TIERS.TBM_PARTNER,
    description: `Cash sponsorship — incredibly helpful for purchasing parts and rare components. Huge thanks!`,
  },
  {
    name: "Brent Bellm",
    src: "/images/Brent Bellm logo.jpg",
    link: "",
    tier: TIERS.TBM_PARTNER,
    description: `Cash sponsorship — helps us acquire parts that are more difficult to find or not sponsored in-kind. Huge thanks!`,
  },
  {
    name: "Automation Direct",
    src: "/images/automation direct screenshot.png",
    link: "https://about.automationdirect.com/",
    tier: TIERS.TBM_PARTNER,
    description: `HMI systems, safety relays, and PLC equipment for our TBM control and safety systems.`,
  },
  {
    name: "MEAN WELL",
    src: "/images/updated meanwell logo.png",
    link: "https://www.meanwell.com/",
    tier: TIERS.TBM_PARTNER,
    description: `2× RSP-750-24 power supply units — industrial-grade 24V DC power conversion.`,
  },
  {
    name: "SureWerx",
    src: "/images/SureWerx Logo.jpg",
    link: "https://www.surewerx.com/",
    tier: TIERS.TBM_PARTNER,
    description: `Hard hats, hi-vis jackets, electrical safety gloves, and N95 respirators for TBM operation.`,
  },
  {
    name: "Cable Leader",
    src: "/images/Cable Leader logo.png",
    link: "https://www.cableleader.com/",
    tier: TIERS.TBM_PARTNER,
    description: `High-quality ethernet cabling and networking equipment for TBM communication systems.`,
  },
  {
    name: "Bud Industries",
    src: "/images/Bud Industries logo.png",
    link: "https://www.budind.com/",
    tier: TIERS.TBM_PARTNER,
    description: `Industrial-grade electronic enclosures and protective cases for TBM electrical components.`,
  },
  {
    name: "Trystar",
    src: "/images/Trystar logo.png",
    link: "https://www.trystar.com/",
    tier: TIERS.TBM_PARTNER,
    description: `Power distribution box for TBM electrical systems.`,
  },

  {
    // TODO: confirm what they provided
    name: "Ramon Perez",
    src: "/images/sponsors/ramon-perez.png",
    link: "",
    tier: TIERS.TBM_PARTNER,
    description: `Thank you for supporting the UATXcavators!`,
  },
  {
    // TODO: confirm what they provided
    name: "Taylor Iron Machine Works",
    src: "/images/sponsors/taylor-iron.png",
    link: "https://tayloriron.com/",
    tier: TIERS.TBM_PARTNER,
    description: `Thank you for supporting the UATXcavators!`,
  },

  // ─── GROUNDHOG SUPPORTERS ────────────────────────────────────────────────
  {
    name: "Oren & Ophira",
    src: null,
    link: "",
    tier: TIERS.GROUNDHOG,
    description: `Cash sponsorship — thank you for your generous support of the UATXcavators!`,
  },
  {
    name: "FK Engineering",
    src: "/images/Logo-FK Engineering below-transparent-high resolution.png",
    link: "https://fkengineering.com/",
    tier: TIERS.GROUNDHOG,
    description: `Cash sponsorship and professional engineering consultation.`,
  },
  {
    name: "Standard Metrics",
    src: "/images/Standard Metrics updated logo.png",
    link: "https://standardmetrics.io/",
    tier: TIERS.GROUNDHOG,
    description: `Cash sponsorship supporting our project development.`,
  },
  {
    name: "EzSBC",
    src: "/images/EzSBC logo.png",
    link: "https://ezsbc.shop/",
    tier: TIERS.GROUNDHOG,
    description: `ESP32 microcontrollers and WiFi modules for TBM automation.`,
  },
  {
    name: "PeerBasics",
    src: "/images/updated peerbasics logo.png",
    link: "https://peerbasics.com/",
    tier: TIERS.GROUNDHOG,
    description: `High-visibility safety vests and PPE for safe TBM operation.`,
  },
  {
    name: "Sunbelt Rentals",
    src: "/images/Sunbelt Rentals Logo.jpg",
    link: "https://www.sunbeltrentals.com/",
    tier: TIERS.GROUNDHOG,
    description: `Duct lift equipment for TBM assembly and testing.`,
  },
  {
    name: "AG Spray Equipment",
    src: "/images/AgSpray_Logo_18.jpg",
    link: "https://www.agspray.com/",
    tier: TIERS.GROUNDHOG,
    description: `12V electric diaphragm pump (5.3 GPM / 60 PSI) for TBM fluid handling and conditioning.`,
  },
  {
    name: "Valin",
    src: "/images/Valin-Process-Control-and-Automation-Trademark-Logo.png",
    link: "https://www.valin.com/",
    tier: TIERS.GROUNDHOG,
    description: `Linear actuators and precision automation components for TBM mechanical systems.`,
  },
  {
    name: "Formlabs",
    src: "/images/formlabs logo.png",
    link: "https://formlabs.com/",
    tier: TIERS.GROUNDHOG,
    description: `Tough 2000 and Rigid 10k resin for prototype cutterhead development.`,
  },
  {
    name: "Shannon and Wilson",
    src: "/images/Shannon and Wilson logo.png",
    link: "https://www.shannonwilson.com/",
    tier: TIERS.GROUNDHOG,
    description: `Cash sponsorship — thank you for supporting the UATXcavators!`,
  },
];

export const tierOrder = [TIERS.SHAI_HULUD, TIERS.TBM_PARTNER, TIERS.GROUNDHOG];
